import { AiUser } from './AiUser'
import { VoiceModel } from './VoiceModel'
import { Attachment, BaseModel } from './common'

export enum SubmissionEarningMethod {
  PRIVATE = 'private', // via email share
  PUBLIC = 'public', // by joining the Kits Artist Library
  BOTH = 'both'
}

export enum SubmissionBranding {
  BRANDED = 'branded',
  ANONYMOUS = 'anonymous'
}

export interface SubmissionStatsForDate {
  date: string
  uniqueUserCount: number
  downloadMs: number
  estimatedPayoutCents: number
}

export enum VoiceModelSubmissionStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PUBLISHED = 'published'
}

export enum VoiceModelSubmissionLanguage {
  ENGLISH = 'English',
  SPANISH = 'Spanish',
  CHINESE = 'Chinese',
  ARABIC = 'Arabic',
  PORTUGUESE = 'Portuguese',
  INDONESIAN = 'Indonesian',
  FRENCH = 'French',
  JAPANESE = 'Japanese',
  RUSSIAN = 'Russian',
  GERMAN = 'German',
  KOREAN = 'Korean',
  HINDI = 'Hindi',
  TURKISH = 'Turkish',
  ITALIAN = 'Italian',
  VIETNAMESE = 'Vietnamese',
  BENGALI = 'Bengali',
  Other = 'Other'
}

export enum VoiceModelSubmissionGender {
  MALE = 'Male',
  FEMALE = 'Female',
  NON_BINARY = 'Non Binary'
}

export enum VoiceModelSubmissionVoiceType {
  SINGING = 'Singing',
  RAPPING = 'Rapping',
  SPEAKING = 'Speaking'
}

export enum VoiceModelSubmissionTag {
  POP = 'Pop',
  'R&B' = 'R&B',
  ROCK = 'Rock',
  ELECTRONIC = 'Electronic',
  WORLD = 'World',
  JAZZ = 'Jazz'
}

export interface SubmissionDemo extends BaseModel {
  demo: Attachment
  voiceModelSubmissionId: number
}

export interface VoiceModelSubmission extends BaseModel {
  status: VoiceModelSubmissionStatus
  isAcceptanceAcknowledged: boolean
  verificationAudio: Attachment
  earningMethod: SubmissionEarningMethod
  branding: SubmissionBranding
  isAccepted: boolean
  isRejected: boolean
  isPending: boolean
  isPublished: boolean
  isPayable: boolean
  voiceModelId: number
  demos: SubmissionDemo[]
  voiceModel: VoiceModel & { aiUser: AiUser }
}
